export const redirectTo = (redirectUrl = window.location.pathname, redirectDelay = 3000) => {
  setTimeout(() => {
    window.location.pathname = redirectUrl
  }, redirectDelay)
};
